__turbopack_context__.v({
  "button": "ZsBQ0a_button",
  "button-border": "ZsBQ0a_button-border",
  "button-border-category": "ZsBQ0a_button-border-category",
  "button-border-group": "ZsBQ0a_button-border-group",
  "button-border-komunitas": "ZsBQ0a_button-border-komunitas",
  "button-border-komunitas-beranda": "ZsBQ0a_button-border-komunitas-beranda",
  "button-border-komunitas-detail-artikel": "ZsBQ0a_button-border-komunitas-detail-artikel",
  "button-border-phase": "ZsBQ0a_button-border-phase",
  "button-text": "ZsBQ0a_button-text",
});
